/* eslint-disable @typescript-eslint/no-explicit-any */
import { CONTENT_TYPE_KEYS, BASE_API } from '../utils/constants'
import { getAccessToken } from '../utils/getAlefuser'
import { getSelectedOrganization } from '../utils/selectedOrganization'

export type getFiltersResponse = {
  eventTypesAndActions: [{ key: string; value: string }]
  statuses: [{ key: string; value: string }]
}
const getFilters = async (type: CONTENT_TYPE_KEYS): Promise<getFiltersResponse> => {
  try {
    const URI = type === 'ALL' ? `${BASE_API}/audit/filters` : `${BASE_API}/audit/filters?entityType=${type}`
    const req = await fetch(URI, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json',
        'X-Tenantid': getSelectedOrganization()
      }
    })
    if (req.status !== 200) {
      throw new Error('request Error')
    }
    const data = await req.json()
    return data
  } catch (e) {
    console.error(e)
    return {
      eventTypesAndActions: [{ key: '', value: '' }],
      statuses: [{ key: '', value: '' }]
    }
  }
}

export default getFilters
